import React from "react";
import { Link } from "react-router-dom";
import { AuthLayout } from "../components/auth/AuthLayout";
import { apiRequest, ApiError } from "../api/client";

export default function ForgotPasswordPage() {
  const [email, setEmail] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);
  const [success, setSuccess] = React.useState<string | null>(null);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);
    setSuccess(null);
    setLoading(true);
    try {
      const response = await apiRequest<{ message: string }>("/auth/forgot-password", {
        method: "POST",
        body: { email: email.trim() },
      });
      setSuccess(response.message || "Si el email existe, te hemos enviado un enlace.");
    } catch (err) {
      const message =
        err instanceof ApiError
          ? err.message
          : err instanceof Error
          ? err.message
          : "No se pudo solicitar la recuperación";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Recuperar contraseña"
      subtitle="Introduce tu email y te enviaremos un enlace para crear una nueva contraseña."
      footer={
        <p className="section-subtitle">
          ¿Recuerdas tu contraseña? <Link to="/auth/login">Volver al login</Link>
        </p>
      }
    >
      <form className="form-grid" onSubmit={handleSubmit} noValidate>
        {error && (
          <div className="empty-state" style={{ borderColor: "rgba(220, 38, 38, 0.4)", color: "#b91c1c" }}>
            {error}
          </div>
        )}
        {success && (
          <div className="empty-state" style={{ borderColor: "rgba(16, 185, 129, 0.3)", color: "#166534", background: "rgba(236,253,245,.9)" }}>
            {success}
          </div>
        )}
        <label style={{ fontWeight: 600, color: "#334155" }}>
          Email
          <input
            className="input"
            type="email"
            placeholder="tuemail@dominio.com"
            value={email}
            onChange={event => setEmail(event.target.value)}
            required
            autoComplete="email"
          />
        </label>

        <button type="submit" className="btn btn-primary" disabled={loading} style={{ justifyContent: "center" }}>
          {loading ? "Enviando..." : "Enviar enlace de recuperación"}
        </button>
      </form>
    </AuthLayout>
  );
}
